namespace GeniuzPOS.Product {
    export class QryMasterColumns {
        static columnsKey = 'Product.QryMaster';
    }
}
